import React from 'react'
import { NavLink, Switch, Route } from 'react-router-dom'
import { Tarjeta } from './pagos/Tarjeta'
import { Tienda } from './pagos/Tienda'
import { Spei } from './pagos/Spei'
import { Registro } from './pagos/Registro'
import { Practicaja } from './pagos/Practicaja'

export const Pagar = () => {

    return (
        <>
            <div className="card">
                <div className="card-header">
                <h5 className="card-title">
                    Generar ficha de pago:
                </h5>
                    <ul className="nav nav-pills card-header-pills">
                        <li className="nav-item">
                            <NavLink exact to={`/pagos/transferencias`} className="nav-link">
                                Transferencias
                            </NavLink>
                        </li>
                        {/* <li className="nav-item">
                            <NavLink to={`/pagos/tarjeta`} className="nav-link">
                                Tarjeta
                            </NavLink>
                        </li> */}
                        <li className="nav-item">
                            <NavLink to={`/pagos/tiendas`} className="nav-link">
                                Comercios
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to={`/pagos/practicaja`} className="nav-link">
                                Practicaja BBVA
                            </NavLink>
                        </li>
                    </ul>
                </div>
                <div className="card-body">
                    <Switch>
                        <Route path={`/pagos/tarjeta`} component={Tarjeta} />
                        <Route path={`/pagos/tiendas`} component={Tienda} />
                        <Route path={`/pagos/registro`} component={Registro} />
                        <Route path={`/pagos/practicaja`} component={Practicaja} />
                        <Route path={`/pagos/transferencias`} component={Spei} />
                    </Switch>
                </div>
                {/* <NavLink to={`/pagos/registro`} className="nav-link text-dark">
                    <small>**Para registrar los pagos en practicaja/ventanilla anteriores al dia 26 de febrero, haz <strong>clic aquí</strong></small>
                </NavLink> */}
            </div>
        </>
    )
}
